module.exports = __webpack_public_path__ + "img/2026-02-27b_2.5b6ea4fb.jpg";